import {Directive, Input} from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';

@Directive({
    selector: '[nr-min-value][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: NrMinValueDirective,
            multi: true
        }
    ],
    standalone: false
})

export class NrMinValueDirective implements Validator {

	// tslint:disable-next-line:no-input-rename
	@Input('nr-min-value') minValue: number;

	registerOnValidatorChange(fn: () => void): void {
	}

	validate(control: AbstractControl): ValidationErrors | null {
		if (isNaN(control.value)) {
			return null;
		}
		if (parseInt(control.value, 10) < this.minValue) {
			return {minValue: true};
		}
		return null;
	}
}
